var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58,10H3.7a.91.91,0,0,0-.81,1v5a.9.9,0,0,0,.81,1H5.58a.91.91,0,0,0,.81-1V11A.91.91,0,0,0,5.58,10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93,3H9.05a.91.91,0,0,0-.81,1v12a.91.91,0,0,0,.81,1h1.88a.9.9,0,0,0,.81-1V4A.9.9,0,0,0,10.93,3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.29,6.49H14.4a.91.91,0,0,0-.82,1v8.46a.91.91,0,0,0,.82,1h1.89a.91.91,0,0,0,.82-1V7.46A.91.91,0,0,0,16.29,6.49Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavData);
export default __webpack_public_path__ + "static/media/nav-data.cc9f54a8d9297ebe2611ff7a3670c316.svg";
export { ForwardRef as ReactComponent };